import React from "react"
import { graphql } from "gatsby"

import { MediaModel } from "../../models/components"
import CaptionImage from "./CaptionImage"
import useDictionary from "../../hooks/useDictionary"

interface Props extends MediaModel {
  cssClass?: string
  pageContext: any
}

const defaultProps = {}

export const Media: React.FC<Props> = props => {
  // console.log("Media: ", props)
  if (!props.image && !props.file) return null

  if (props.image)
    return <CaptionImage {...props} pageContext={props.pageContext} />

  if (props.file) return <h3>{useDictionary("File Download", props.pageContext.locale)}</h3>

  return null
}

Media.defaultProps = defaultProps

export default Media

/******************************************************
	Data
******************************************************/
export const query = graphql`
  fragment MediaFields on Contentstack_media {
    id
    image {
      ...CmsImageFields
      gatsbyImageData(quality: 95)
    }
    file {
      ...CmsAssetFields
    }
    alt_text
    caption
    anchor {
      ...AnchorFields
    }
    internal {
      type
    }
  }
`
